import React from 'react';
import { useSelector } from 'react-redux';

import { ShieldSolidIcon } from '@interstate/components/Icons';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { getCreditScoreSource } from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { getCreditScoreSourceLabel } from '../utils/creditScoreSourceLabel';
import {
    StyledCreditSourceLabel,
    StyledCreditSourceText,
    StyledLeftContent,
    StyledSelfReportedText
} from './AltSoftPullConsentAlert.style';

export interface CreditSourceHeaderProps {
    dataTestId?: string;
}

const CreditSourceHeader: React.FC<CreditSourceHeaderProps> = ({ dataTestId }) => {
    const theme = useInterstateTheme();
    const creditScoreSource = useSelector(getCreditScoreSource);
    const sourceLabel = getCreditScoreSourceLabel(creditScoreSource);

    return (
        <StyledLeftContent data-testid={dataTestId}>
            <StyledCreditSourceLabel>
                <ShieldSolidIcon aria-hidden="true" width="16" height="16" color={theme.tokens.SemColorSurfaceButtonPrimaryRest} />
                <StyledCreditSourceText variant="label-sm" tag="span">
                    CREDIT SOURCE
                </StyledCreditSourceText>
            </StyledCreditSourceLabel>
            <StyledSelfReportedText variant="h5" tag="div">
                {sourceLabel}
            </StyledSelfReportedText>
        </StyledLeftContent>
    );
};

export default CreditSourceHeader;
